import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { compoundsRoutes } from './compounds.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'
import { CompoundsComponent } from './compounds.component'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { UpdateCompoundComponent } from './update-compound/update-compound.component'
import { ReactiveFormsModule } from '@angular/forms'
import { CreateCompoundComponent } from './create-compound/create-compound.component'
import { ContentLoadingModule } from '@components/content-loading/content-loading.module'
import { RadioModule } from '@components/radio/radio.module'
import { PageHeaderModule } from '@components/page-header/page-header.module'
import { UpdateCompoundGeneralComponent } from './update-compound/general/general.component'
import { UpdateCompoundPaymentsComponent } from './update-compound/payments/payments.component'
import { PaymentCardModule } from '@components/payment-card/payment-card.module'
import { UpdateCompoundDocumentsComponent } from './update-compound/documents/documents.component'

@NgModule({
  declarations: [
    CompoundsComponent,
    UpdateCompoundComponent,
    CreateCompoundComponent,
    UpdateCompoundGeneralComponent,
    UpdateCompoundPaymentsComponent,
    UpdateCompoundDocumentsComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(compoundsRoutes, { scrollPositionRestoration: 'top' }),
    HttpClientModule,
    SharedModule,
    ReactiveFormsModule,
    ContentLoadingModule,
    ContentEditableModule,
    PageHeaderModule,
    PaymentCardModule,
    RadioModule,
  ],
})
export class CompoundsModule {}
